module.exports = __webpack_public_path__ + "img/desk_with_stuff.7200d095.webp";